/* Cloud Store CBD · lignes produit de la sélection des pages villes (snippets/cs-product-row.liquid).
   Pastille = choix du format (prix, barré, variante du bouton). Bouton = POST /cart/add.js puis cart:refresh + cart:added
   (cs-cart.js ouvre le tiroir et met à jour la jauge) : même mécanisme que cs-product-card et cs-hv3. Vanilla, sans dépendance. */
(function () {
  if (window.__csRowInit) return;
  window.__csRowInit = true;
  var doc = document;

  function setMsg(row, text, ok) {
    var m = row.querySelector('[data-cs-row-msg]');
    if (!m) return;
    m.classList.toggle('is-ok', !!ok);
    m.textContent = text || '';
  }

  function ariaLabel(row, label, price) {
    return 'Ajouter ' + (row.getAttribute('data-name') || '') + (label ? ', ' + label : '') + ', ' + price.replace(/\u00a0/g, ' ') + ' au panier';
  }

  function selectPill(pill) {
    var row = pill.closest('[data-cs-row]');
    if (!row) return;
    row.querySelectorAll('[data-cs-row-pill]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
    pill.setAttribute('aria-pressed', 'true');
    var btn = row.querySelector('[data-cs-row-add]');
    if (!btn) return;
    var price = pill.getAttribute('data-price') || '';
    var cmp = pill.getAttribute('data-compare') || '';
    btn.setAttribute('data-variant-id', pill.getAttribute('data-variant-id'));
    btn.setAttribute('aria-label', ariaLabel(row, pill.getAttribute('data-label'), price));
    var amt = btn.querySelector('.cs-prow__amt');
    if (amt) amt.textContent = price;
    var cmpEl = btn.querySelector('.cs-prow__cmp');
    var cmpV = btn.querySelector('.cs-prow__cmp-v');
    if (cmpEl && cmpV) {
      cmpV.textContent = cmp;
      if (cmp) cmpEl.removeAttribute('hidden'); else cmpEl.setAttribute('hidden', '');
    }
    setMsg(row, '');
  }

  function addToCart(btn) {
    var row = btn.closest('[data-cs-row]');
    var id = btn.getAttribute('data-variant-id');
    if (!row || !id || btn.disabled) return;
    var t = btn.querySelector('.cs-prow__t');
    btn.disabled = true;
    setMsg(row, '');
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        /* 422 + { description } = ajout refusé (stock, quantité) : on affiche le texte traduit par Shopify. */
        return r.json().catch(function () { return {}; }).then(function (data) {
          if (!r.ok || (data && data.status >= 400)) {
            var err = new Error('cart add refused');
            err.userMessage = (r.status === 422 && data && data.description) || "L'ajout n'a pas marché, réessaie.";
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        btn.classList.add('is-success');
        if (t) t.textContent = 'Ajouté ✓';
        setMsg(row, (row.getAttribute('data-name') || 'Produit') + ' ajouté au panier', true);
        doc.dispatchEvent(new CustomEvent('cart:refresh'));
        doc.dispatchEvent(new CustomEvent('cart:added', { detail: { source: btn } }));
        setTimeout(function () {
          btn.classList.remove('is-success');
          if (t) t.textContent = 'Ajouter';
          btn.disabled = false;
          setMsg(row, '');
        }, 1600);
      })
      .catch(function (err) {
        btn.classList.add('is-error');
        setMsg(row, (err && err.userMessage) || 'Connexion perdue : vérifie ton réseau, puis réessaie.');
        setTimeout(function () { btn.classList.remove('is-error'); btn.disabled = false; }, 1600);
      });
  }

  doc.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-cs-row-pill]');
    if (pill) { selectPill(pill); return; }
    var btn = e.target.closest('[data-cs-row-add]');
    if (btn) addToCart(btn);
  });
})();
